<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'ContentMain'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/ContentMain.vue